import { axios } from 'lib/axios';
import { queryClient } from 'lib/react-query';
import { useNotificationStore } from 'stores/notifications';
import PropTypes from 'prop-types';
import { useMutation } from 'react-query';

export const updateAvatar = ({ data, id }) => {
  return axios.patch(`/users/${id}/avatar`, data);
};

updateAvatar.propTypes = {
  id: PropTypes.string.isRequired,
};

export const useUpdateAvatar = ({ config } = {}) => {
  const { addNotification } = useNotificationStore();

  return useMutation({
    onMutate: async (updatingUser) => {
      await queryClient.cancelQueries(['auth-user', updatingUser?.id]);

      const previousUser = queryClient.getQueryData[('auth-user', updatingUser?.id)];

      queryClient.setQueryData(['auth-user', updatingUser?.id], {
        ...previousUser,
        ...updatingUser.data,
        id: updatingUser.id,
      });

      return { previousUser };
    },
    onError: (_, __, context) => {
      if (context?.previousUser) {
        queryClient.setQueryData(['auth-user', context.previousUser.id], context.previousUser);
      }
    },
    onSuccess: (data) => {
      queryClient.refetchQueries(['auth-user', data._id]);
      addNotification({
        type: 'success',
        title: 'Profile Photo Updated',
      });
    },
    ...config,
    mutationFn: updateAvatar,
  });
};
